import { render } from "./NewProducts.vue?vue&type=template&id=6068b443&scoped=true"
import script from "./NewProducts.vue?vue&type=script&lang=js"
export * from "./NewProducts.vue?vue&type=script&lang=js"

import "./NewProducts.vue?vue&type=style&index=0&id=6068b443&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6068b443"]])

export default __exports__